<template>
  <container class="error-404">
    <introduction
      class="error-404__introduction"
      :title="$t('title')"
      :subtitle="$t('subtitle')"
    >
      <div class="error-404__content">
        <div>
          <p><strong>{{ $t('reason.title') }}</strong></p>

          <ul>
            <li
              v-for="item in $t('reason.list')"
              :key="item"
            >
              {{ item }}
            </li>
          </ul>

          <p><strong>{{ $t('solution.title') }}</strong></p>

          <action-link
            router-link="/"
            color="primary"
            exact
          >
            {{ $t('solution.link') }}
          </action-link>
        </div>
        <img
          src="../img/404.jpg"
          srcset="../img/404@2.5x.jpg 2.5x"
          alt=""
          class="error-404__image"
        >
      </div>
    </introduction>
  </container>
</template>

<script>
import actionLink from '../components/actionLink.vue'
import container from '../components/container.vue'
import introduction from '../components/introduction.vue'

export default {
  name: 'VError',

  components: {
    actionLink,
    container,
    introduction
  }
}
</script>

<i18n locale="en">
{
  "title": "No man's land in Wunderland",
  "subtitle": "This page doesn't exist",
  "reason": {
    "title": "Oops, it seems like something went wrong… This may have one of the following reasons:",
    "list": [
      "The page has moved to an unknown address.",
      "The page has been deleted.",
      "You accidentally entered the wrong URL in your browser. Admittedly, that's reeeeaaaally unrealistic.",
      "You just love 404 pages."
    ]
  },
  "solution": {
    "title": "What now?",
    "link": "Return to homepage"
  }
}
</i18n>

<i18n locale="de">
{
  "title": "Niemandsland im Wunderland",
  "subtitle": "Diese Seite existiert leider nicht",
  "reason": {
    "title": "Huch, hier scheint irgendetwas schief gegangen zu sein… Dies kann einen der folgenden Gründe haben:",
    "list": [
      "Die Seite ist unbekannt verzogen.",
      "Die Seite wurde gelöscht.",
      "Sie haben aus Versehen die falsche Adresse in den Browser eingetippt. Zugegeben, seeehr unwahrscheinlich.",
      "Sie mögen gerne 404er-Seiten."
    ]
  },
  "solution": {
    "title": "Was nun?",
    "link": "Zurück zur Startseite"
  }
}
</i18n>

<style lang="scss">
@import "../css/variables";
@import "../css/mixins";

.error-404__introduction {
  @include vertical-spacing;
}

.error-404__content {
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: $breakpoint-lg) {
    flex-direction: row;
  }
}

.error-404__image {
  flex-shrink: 0;
  order: -1;
  margin-bottom: $gutter-sm;

  @media (min-width: $breakpoint-lg) {
    order: 0;
    margin-bottom: 0;
    margin-left: $gutter-lg;
  }
}
</style>
